import IUserService from "../../spi/IUserService";
import FirebaseService from "../../impl/firebase/FirebaseService"
import IUser, { IUserStatusType } from "../../../types/IUser";
import IRole from "../../../types/IRole";

export default class FirebaseUserService implements IUserService {
    datasource?: any;

    async getUsers(searchTerm: string, rowsPerPage: number, pageNumber: number): Promise<Array<IUser>> {
        let users:Array<IUser> = [];
        try {
            const snapshot = await FirebaseService.getInstance()
                            .users()
                            .get()
            
            snapshot.forEach((child:any) => {
                const key = child.id;
                const userVal = child.data();
                const user:IUser = this._getIUser(key, userVal);
                users.push(user);
            });
        }catch(e){
            throw e;
        }
        return users;
    }

    private _getIUser(key:string, userVal:any):IUser{
        return {
            uid: key,
            userName: userVal.username,
            title: userVal.title,
            firstName: userVal.firstName,
            lastName: userVal.lastName,
            status: userVal.status == 'Active' ? IUserStatusType.Active : IUserStatusType.InActive,
            lastLogin: userVal.lastLogin,
            image: userVal.image,
            phone: userVal.phone,
            email: userVal.email,
            createdOn: userVal.createdOn,
            roles: userVal.roles ? userVal.roles.map((role:any) => role.name) : []
        }
    }

    async getUser(userId: string): Promise<IUser> {
        let user: IUser = {} as IUser;
        debugger;
        try {
            const snapshot:any = FirebaseService.getInstance()
                                    .user(userId)
                                    .get();
            const key = snapshot.id;
            const userVal = snapshot.child();
            user = this._getIUser(key, userVal);
        }catch(e){
            throw e;
        }
        return user;
    }

    async createUser(user:IUser):Promise<IUser>{
        let retUser:IUser = {} as IUser;
        try{
            FirebaseService.getInstance().users().doc().set(user);
            retUser = user;
        }catch(e){
            throw e;
        }
        return retUser;
    }

    async updateUser(user: IUser): Promise<IUser> {
        let updatedUser:IUser = {} as IUser;
        try{
            // document = await FirebaseService.getInstance().document(doc.uid).set(doc);
            const { ...userSnapshot } = user;
            await FirebaseService.getInstance()
                                .user(user.uid)
                                .update({
                                    ...userSnapshot
                                });
            updatedUser = user;
        } catch(e){
            throw e;
        }

        return updatedUser;
    }

    async getRoles(): Promise<Array<IRole>> {
        let roles:Array<IRole> = [];
        try {   
            const snapshot = await FirebaseService.getInstance().roles().get()
            if(!snapshot.empty){
                snapshot.forEach((child:any) => {
                    const key = child.id;
                    const roleVal = child.data();
                    const uiRole:IRole = {
                        name: roleVal.name,
                        description: roleVal.description
                    }
                    roles.push(uiRole);
                }); 
            }
        }catch(e){
            throw e;
        }
        return roles;
    }

    assignRole(uid: string, roles: Array<IRole>): Promise<boolean> {
        throw new Error("Method not implemented.");
    }

    async deleteUser(uid: string): Promise<boolean> {
        return false;
    }
}